import schoolAxiosInstance from "@quest/school-axios";
import { IAssignmentSubmitPayload } from "../types/assignment.type";

export interface IAddCommentPayload {
  answer_comments: {
    answer_id: number;
    comment: string | null;
    is_correct: boolean;
  }[];
}

export interface ISaveAnswerPayload {
  student_id: number;
  assignment_id: number;
  question_id: number;
  question_option_id: number | null;
  customAnswer: string;
  hasCustomAnswer: boolean;
  answer: string;
}

class StudentService {
  private api = schoolAxiosInstance;

  async draftAssignment(data: IAssignmentSubmitPayload) {
    const response = await this.api.post(
      `/assignment/student-assignments/submit`,
      data
    );

    return response.data;
  }

  async saveAnswer(data: ISaveAnswerPayload) {
    const response = await this.api.post(
      `/assignment/student-assignments/save-answer`,
      data
    );

    return response.data;
  }

  async completeAssignment(data: IAssignmentSubmitPayload) {
    const response = await this.api.post(
      `/assignment/student-assignments/complete`,
      data
    );

    return response.data;
  }

  async addComment(comment: string | null, answer_id: number) {
    const response = await this.api.put(
      `/assignment/student-assignments/answer/${answer_id}/comment`,
      { comment }
    );

    return response.data;
  }

  async markAsIsCorrect(answer_id: number, is_correct: boolean) {
    const response = await this.api.put(
      `/assignment/student-assignments/answer/${answer_id}/correct`,
      { is_correct }
    );

    return response.data;
  }

  async acceptAssignment(attempt_id: number, awarded_points?: number) {
    const response = await this.api.put(
      `/assignment/student-assignments/attempt/${attempt_id}/accept`,
      { awarded_points }
    );

    return response.data;
  }

  async rejectAssignment(attempt_id: number) {
    const response = await this.api.put(
      `/assignment/student-assignments/attempt/${attempt_id}/reject`
    );

    return response.data;
  }

  async checkStudentIcaresTestStatus(
    studentId: number | null,
    schoolYear: number | null
  ) {
    const response = await this.api.get(
      `/student/icares-test/check-beroepentest/${studentId}/${schoolYear}`
    );

    return response.data;
  }

  async skipTutorial(idpId: string) {
    const response = await this.api.put(`/users/skip-tutorial/${idpId}`);

    return response.data;
  }
}

export const studentService = new StudentService();
